import React from 'react';
import './App.css';
import UnityGame from './components/UnityGame';

function App() {
  return (
    <div className="App">
      <UnityGame />
    </div>
  );
}

export default App;
